import Service from './Service';
import env from '@/utils/env';
import logger from '@/utils/logger';

/**
 * 令牌相关接口
 */
class RedirectService extends Service {
    /**
     * 安装请求拦截器
     */
    setupRequestInterceptors() {
        // 请求拦截器
        this.axios.interceptors.request.use(
            config => {
                if (env.VUE_APP_LOCAL) {
                    // 反向代理前缀
                    const proxyPrefix = this.isMock ? this.mockPrefix : this.serverPrefix;

                    // 添加反向代理前缀
                    config.url = `${proxyPrefix}/${config.url}`;
                }
                // 如果接口前缀带api/pay/ 则替换为环境变量VUE_APP_NG_SERVER_URL
                config.url = config.url.replace('api/pay/', process.env.VUE_APP_NG_SERVER_URL);

                // 给请求添加时间戳
                config.params = config.params || {};
                config.params.request_no = new Date().getTime();
                return config;
            },
            error => {
                logger.error(error);
                return Promise.reject(error);
            }
        );
    }
    /**
     * 使用临时令牌交换正式令牌
     * @param tempToken
     */
    swapToken(tempToken) {
        return this.axios.post('api/pay/v1/access_token', {
            tempToken
        });
    }
}

const redirectService = new RedirectService();
export default redirectService;
